/* eslint-disable */
import { call, ReviewInitData } from 'services/api-service'

/**
 * Initialization data for the review form
 *
 * @method
 * @name ApiService#reviewInitData
 * @param {string} contextToken -
 * @param {string} sku -
 * @param {string} checkoutSiteKey -
 * @param {string} ssoProfileToken -
 */
function reviewInitData(parameters: {
  'context-token'?: string
  sku: string
  checkoutSiteKey?: string
  ssoProfileToken?: string
}): Promise<ReviewInitData> {
  return call<ReviewInitData>(
    'GET',
    '/{siteKey}/review/initData',
    parameters,
    ['sku'],
    ['sku', 'checkoutSiteKey', 'ssoProfileToken'],
    ['context-token']
  )
}

export default { reviewInitData }
